import { Pipe, PipeTransform } from '@angular/core';
import { QStatus } from '../synchronization.model';

@Pipe({
  name: 'queueStatusLabel',
  standalone: true
})
export class QueueStatusLabelPipe implements PipeTransform {
  private readonly statusTranslations: { [key in QStatus]?: string } = {
    [QStatus.None]: 'Ingen',
    [QStatus.Waiting]: 'Venter',
    [QStatus.Paused]: 'Pause',
    [QStatus.Validating]: 'Validerer',
    [QStatus.ValidatingData]: 'Validerer data',
    [QStatus.Queued]: 'I kø',
    // 40 is written the moment a delkørsel is taken off the queue, before any work — the work itself
    // is 42 → 44 → 46. "Udfører" read as if 40 were the work, and made the sequence look reversed.
    [QStatus.Executing]: 'Påbegyndt',
    [QStatus.PrepareExecute]: 'Forbereder',
    [QStatus.ReadDataExecute]: 'Læser data',
    // Only written on the write/delete path: the bulk merge or the DELETE itself.
    [QStatus.SyncDataExecute]: 'Skriver data',
    [QStatus.PreSynchronizationQueued]: 'Præ-synk i kø',
    [QStatus.PreSynchronizationPrepare]: 'Forbereder præ-synk',
    [QStatus.PreSynchronizationExecute]: 'Udfører præ-synk',
    [QStatus.PostSynchronizationQueued]: 'Post-synk i kø',
    [QStatus.PostSynchronizationPrepare]: 'Forbereder post-synk',
    [QStatus.PostSynchronizationExecute]: 'Udfører post-synk',
    [QStatus.Done]: 'Færdig',
    [QStatus.DoneWithWarnings]: 'Færdig m. advarsler',
    [QStatus.DoneWithErrors]: 'Færdig m. fejl',
    [QStatus.Warnings]: 'Advarsler',
    [QStatus.Failed]: 'Fejlet',
    [QStatus.SystemFailed]: 'Systemfejl',
    [QStatus.Cancelled]: 'Annulleret'
  };

  // The null branch below already existed; the signature just never admitted it.
  transform(status: QStatus | undefined | null): string {
    if (status === undefined || status === null) return '';
    return this.statusTranslations[status] || QStatus[status];
  }
}
